import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import Button from '../Button/Button.jsx';
import Input from '../Input/Input.jsx';
import Icon from './Icon/Icon.jsx';
import HouseIcon from '../../assets/images/house_icon.svg';

import realEstateTypeConfig from '../PriceCheck/Widget/realEstateTypeConfig.js';
import { getProfile, profileTypes } from './stylingProfiles.js';
import tracking from '../../tracking/tracking.js';
import { navigateTo, TAB } from '../Navigation/Menu/menuConfig';

import styles from './PriceCheckInput.less';
import actions from '../PriceCheck/actions';

export const PriceCheckInput = (props) => {
  const navigate = useNavigate();

  const onClickHandler = (event) => {
    event.preventDefault();
    props.onClickHandeler();
    props.priceCheckUpdateRealEstateType('');
    navigateTo(navigate, TAB.priceCheck);
  };

  const getHandler = (name) => (event) => {
    props.updateInputs(name, event.target.value);
  };

  const renderInput = (item, reportingLabel, additionalClass) => {
    const { priceCheckInputs } = props;
    const onFocus = reportingLabel ? () => tracking.report(reportingLabel) : () => {};

    return (
      <Input
        text={item.title}
        type={item.type}
        placeholder={item.placeholder}
        inputInfoText={item.inputInfoText}
        onChange={getHandler(item.name)}
        maxNumber={item.maxNumber}
        minNumber={item.minNumber}
        value={priceCheckInputs[item.name]}
        className={`input-${item.name}`}
        onFocus={onFocus}
        additionalClass={additionalClass}
      />
    );
  };

  const renderButtonHeading = (text) => (
    <div className="grid grid-flex" id="cta-price-check-button-heading">
      <Icon icon={HouseIcon} alt={text} />
      <span className={`${styles.buttonHeading} grid-item two-third padding-left-xs`}>{`${text}:`}</span>
    </div>
  );

  const renderWidgetOverviewPage = () => {
    const { stylingProfile, realEstateType } = props;
    const properConfig = realEstateTypeConfig.getFor(realEstateType).inputs;
    const reporting = props.reporting || {};
    const inputsReporting = reporting.inputs || {};
    const profile = getProfile(stylingProfile);

    return (
      <>
        <div className={`grid-item one-whole ${styles.widgetCosma} grid-align-end`}>
          <div className="grid gutter grid-flex grid-fill-rows">
            <div className="grid-item lap-one-fourth palm-one-whole desk-one-whole">
              <div className="grid gutter grid-flex grid-justify-center">
                {properConfig.map((item, index) => (
                  <div
                    key={index}
                    className={`grid-item desk-one-whole palm-one-whole lap-one-half ${styles.widgetMaxWidthInput}`}
                  >
                    {renderInput(item, inputsReporting[item.name])}
                  </div>
                ))}
              </div>
            </div>
            <div
              className={`grid-item grid-item-fixed-width desk-one-whole palm-one-whole align-right grid-align-end ${styles.widgetCosmaButtonRow}`}
            >
              <Button
                buttonClass="button-primary"
                text={profile.buttonText}
                additionalClass="price-check-cta-button margin-top-m"
                reportingLabels={reporting.button}
                onClickHandler={(e) => onClickHandler(e)}
              />
            </div>
          </div>
        </div>
      </>
    );
  };

  const renderWidgetPriceDevDesktopTablet = () => {
    const { stylingProfile, realEstateType } = props;
    const properConfig = realEstateTypeConfig.getFor(realEstateType).inputs;
    const reporting = props.reporting || {};
    const inputsReporting = reporting.inputs || {};
    const profile = getProfile(stylingProfile);
    const buttonHeading = profile.buttonHeading[realEstateType];

    const inputs = properConfig.map((item, index) => (
      <div key={index} className="grid-item padding-right-m">
        <div className={styles.cosmaWidthInput}>
          {renderInput(item, inputsReporting[item.name], styles.bannerInput)}
        </div>
      </div>
    ));

    return (
      <div className={`one-whole grid grid-flex ${styles.bannerWrapperLegacyCosma}`}>
        {inputs}
        <div
          className={`grid-item grid-align-end grid-item-fixed-width palm-one-whole ${
            profile.buttonWrapper[realEstateType]
          } ${properConfig.length > 2 ? styles.buttonContainer3Field : ''}`}
          id="cta-price-check-button"
        >
          {buttonHeading && renderButtonHeading(buttonHeading)}
          <Button
            buttonClass="button-primary"
            text={profile.buttonText[realEstateType]}
            additionalClass={`price-check-cta-button margin-top-m ${styles.bannerButton}`}
            reportingLabels={reporting.button}
            onClickHandler={(e) => onClickHandler(e)}
          />
        </div>
      </div>
    );
  };

  const renderWidgetPriceDevMobile = () => {
    const { stylingProfile, realEstateType } = props;
    const reporting = props.reporting || {};
    const profile = getProfile(stylingProfile);

    return (
      <Button
        buttonClass="button-primary"
        additionalClass="one-whole font-s price-check-cta-button"
        text={profile.buttonText[realEstateType]}
        reportingLabels={reporting.button}
        onClickHandler={(e) => onClickHandler(e)}
      />
    );
  }

  const { stylingProfile } = props;

  return (
    <>
      {stylingProfile === profileTypes.OVERVIEW_PAGE && renderWidgetOverviewPage()}
      {stylingProfile === profileTypes.PRICEDEVELOPMENT_DESKTOP_AND_TABLET && renderWidgetPriceDevDesktopTablet()}
      {stylingProfile === profileTypes.PRICEDEVELOPMENT_MOBILE && renderWidgetPriceDevMobile()}
    </>
  );
};

PriceCheckInput.defaultProps = {
  reporting: {},
  priceCheckUpdateRealEstateType: () => {},
  onClickHandeler: () => {},
};

PriceCheckInput.propTypes = {
  realEstateType: PropTypes.string.isRequired,
  stylingProfile: PropTypes.oneOf([
    profileTypes.PRICEDEVELOPMENT_DESKTOP_AND_TABLET,
    profileTypes.OVERVIEW_PAGE,
    profileTypes.PRICEDEVELOPMENT_MOBILE,
  ]).isRequired,
  priceCheckInputs: PropTypes.object.isRequired,
  updateInputs: PropTypes.func.isRequired,
  reporting: PropTypes.object,
  priceCheckUpdateRealEstateType: PropTypes.func,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  priceCheckUpdateRealEstateType: (realEstateType) => dispatch(actions.priceCheckRealEstateType(realEstateType)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PriceCheckInput);
